import connectSearchBox from 'instantsearch.js/es/connectors/search-box/connectSearchBox';

const searchBoxTemplate = widgetParams => {
    const id = `searchboxwithlabel-${Math.random().toString(36).substr(2, 9)}`;
    return `
        <div class="ais-SearchBoxWithLabel">
            <form class="ais-SearchBoxWithLabel-form" role="search" novalidate>
                <div class="ais-SearchBoxWithLabel-wrapper">
                    <label for="${id}" class="ais-SearchBoxWithLabel-label">${widgetParams.label}</label>
                    <input class="ais-SearchBoxWithLabel-input" id="${id}" type="search"
                        placeholder="${widgetParams.placeholder}"
                        autocomplete="off" autocorrect="off" autocapitalize="off"
                        spellcheck="false" maxlength="512">
                </div>
                ${
                    widgetParams.showSubmit
                        ? `<button type="submit" class="ais-SearchBoxWithLabel-submit"${
                              widgetParams.submitAriaLabel
                                  ? ` aria-label="${widgetParams.submitAriaLabel}"`
                                  : ''
                          }><svg aria-hidden="true" class="ais-SearchBoxWithLabel-submitIcon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 512 512"><path d="M508.5 468.9L387.1 347.5c-2.3-2.3-5.3-3.5-8.5-3.5h-13.2c31.5-36.5 50.6-84 50.6-136C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c52 0 99.5-19.1 136-50.6v13.2c0 3.2 1.3 6.2 3.5 8.5l121.4 121.4c4.7 4.7 12.3 4.7 17 0l22.6-22.6c4.7-4.7 4.7-12.3 0-17zM208 368c-88.4 0-160-71.6-160-160S119.6 48 208 48s160 71.6 160 160-71.6 160-160 160z"/></svg></button>`
                        : ''
                }
            </form>
        </div>
    `;
};

const renderSearchBox = (renderOptions, isFirstRender) => {
    const { query, refine, clear, isSearchStalled, widgetParams } = renderOptions;

    const container = document.querySelector(widgetParams.container);
    if (isFirstRender) {
        container.innerHTML = searchBoxTemplate(widgetParams);
    }

    const form = container.querySelector('form');
    const input = container.querySelector('input[type="search"]');

    if (isFirstRender) {
        const updateOnInput = e => {
            e.preventDefault();
            e.stopPropagation();
            refine(input.value);
        };
        form.addEventListener('submit', updateOnInput);
        input.addEventListener('input', updateOnInput);
    }

    if (input !== document.activeElement && input.value !== query) {
        input.value = query;
    }
};

export const searchBoxWithLabelWidget = connectSearchBox(renderSearchBox, () => {});
